import { Payment } from '@yuno/sdk-web-core/dist/types'
import { CheckoutInfo } from '../../../types'

export const getPaymentMethodTypeList = (
  paymentMethodType?: string
): Payment.Type[] => {
  if (!paymentMethodType) return []
  return paymentMethodType
    .split(',')
    .map((item) => item.trim()) as Payment.Type[]
}

export const getPaymentMethods = (
  paymentMethodType?: string,
  paymentMethods?: Payment.Method[]
): Payment.Method[] => {
  const paymentMethodTypeList = getPaymentMethodTypeList(paymentMethodType)

  return (
    paymentMethods?.filter((paymentMethod) =>
      paymentMethodTypeList.includes(paymentMethod.type)
    ) ?? []
  )
}

const FIRST_PAYMENT_METHOD = 0

export const isFirstPaymentMethod = (
  paymentMethod: Payment.Method,
  index: number
) => paymentMethod.type === 'CARD' && index === FIRST_PAYMENT_METHOD

export const hasCardForm = (checkoutInfo: CheckoutInfo, paymentMethods: Payment.Method[]): boolean => {
  const filteredPaymentMethods = getPaymentMethods(
    checkoutInfo.payment_link.payment_method_types,
    paymentMethods
  )
  const cardFound = filteredPaymentMethods.find(pm => pm.type === Payment.Type.CARD)
  return Boolean(cardFound)
}

export const getCustomButtonStyles = (styles: string | null) => {
  if (styles === null || styles === undefined) return ''

  const style = JSON.parse(styles).styles.button

  const customStyles = `
    button, button.Yuno-button {
      color: ${style.text.color};
      background-color: ${style.background.color};

      &:hover {
        background-color: ${style.background.hover.color};
      }
    }
  `

  return customStyles
}
